(ns manage.content-configuration-page.view.add-item
  (:require ["@mui/material/Stack$default" :as Stack]
            [clojure.spec.alpha :as spec]
            [common.ui.add-item :as ui.add-item]
            [manage.content-configuration-page.view.input :as view.input]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :refer [$]]))

(spec/def ::new-value
  (spec/or :subscription :reframe/sub-or-event
           :fn fn?))

(defn input
  [{:add-item/keys [add-fn input-props new-value parent]
    validation-schema :validation/schema
    :or {new-value (constantly "")} :as cfg}]
  (r/with-let [new-value-format (first (spec/conform ::new-value new-value))
               subscription (case new-value-format
                              :subscription (rf/subscribe new-value)
                              :fn (r/atom (new-value)))
               current-value (r/atom @subscription)
               add (fn [value]
                     (add-fn value)
                     (when (= new-value-format :fn)
                       (reset! subscription (new-value))))]
    ($ Stack {:direction "row"
              :alignItems "start"
              :gap 1}
       (r/as-element
        [view.input/input-save-on-enter
         (-> {:subscription subscription
              :on-change (partial reset! current-value)
              :on-save add
              :validation/stages #{:save-blocking :warning}
              :entity/parent parent
              :form-field-props {:sx #js {:flexGrow 1}}
              :control-props (merge {:autoFocus true
                                     :onFocus #(.select (.-target %))}
                                    input-props)}
             (cond-> (some? validation-schema) (assoc :validation/schema validation-schema)))])
       ($ ui.add-item/add-button
          (-> cfg
              (assoc :current-value @current-value)
              (update :add-item/add-button-props
                      (partial merge {:onClick #(add @current-value)})))))))

(defn with-input-validation [{:validation/keys [schema] :as cfg}]
  (cond-> (assoc cfg :add-item/value-editor input)
    (and (nil? (:add-item/valid? cfg)) (some? schema))
    (assoc :add-item/valid?
           (fn [value]
             (->> @(rf/subscribe [:validation/results-from-value schema value])
                  (not-any? #(= (:stage %) :save-blocking)))))))

(defn view [cfg]
  ($ ui.add-item/view (with-input-validation cfg)))
